import { Injectable, TemplateRef } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class UserTokenService {

  constructor() {


  }

  private token:string;
  /**
   * name
   */
  public set(_token:string) {
    if(!_token){
      throw Error("set token is invalid");
    }
    this.token=_token;
    localStorage.setItem("Token",_token);
  }
  public get():string{
    if(!this.token){
      this.token=localStorage.getItem("Token")??"";
    }
    return this.token;
  }

  public clear():void{
    this.token=null;
  }
}
